import React, { useEffect } from 'react';
import {
  initiateGlobalPayment3DsAuthentication,
  dispatchGlobalpaymentsInitiatePaymentAction,
  getOneTimeGlobalPaymentToken,
} from '../utils/GlobalPaymentUtils';
import {
  redirectToPaymentFailurePage,
  redirectToProcessingPage,
  isCurrentPageRedirectFromRNA,
} from 'common/utilities/utils';
import PAYMENT_CONSTANTS from 'organisms/Payment/constants/PaymentConstants';
import { getPlaceOrderValidation, updateClickPlaceOrderState } from 'common/utilities/PaymentUtils';

const { GLOBAL_PAYMENTS_CONSTANTS } = PAYMENT_CONSTANTS;

const GlobalPaymentCreditDebitCardHiddenForm = props => {
  const { checkoutDetails, updateCheckoutDetails } = props;

  useEffect(() => {
    document?.getElementById?.('payment-provider-place-order-form')?.replaceChildren?.();
  }, []);

  useEffect(() => {
    getPlaceOrderValidation(checkoutDetails)
      ? getOneTimeGlobalPaymentToken(props)
      : document?.getElementById?.('payment-provider-place-order-form')?.replaceChildren?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    checkoutDetails?.paymentCardDetails?.isFormValid,
    checkoutDetails?.billingAddressAndSaveCard?.isBillingAddressFormDetailsValid,
    checkoutDetails?.billingAddressAndSaveCard?.defaultAddressSelected,
    checkoutDetails?.cardNickNameError,
  ]);

  useEffect(() => {
    if (checkoutDetails?.isAddNewCard) {
      if (isCurrentPageRedirectFromRNA(window.location)) {
        window.ReactNativeWebView.postMessage(JSON.stringify({ success: checkoutDetails }));
      } else {
        checkoutDetails?.globalPaymentsOneTimeResponse?.paymentReference && redirectToProcessingPage(props);
      }
    } else {
      checkoutDetails?.globalPaymentsOneTimeResponse?.paymentReference &&
        updateClickPlaceOrderState(checkoutDetails, updateCheckoutDetails);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkoutDetails?.globalPaymentsOneTimeResponse?.paymentReference]);

  useEffect(() => {
    if (checkoutDetails?.globalPaymentCheck3DsVersion?.serverTransactionId) {
      // Non-3ds
      checkoutDetails?.globalPaymentCheck3DsVersion?.enrolled === GLOBAL_PAYMENTS_CONSTANTS?.NOT_ENROLLED &&
        checkoutDetails?.globalPaymentCheck3DsVersion?.liabilityShift !== GLOBAL_PAYMENTS_CONSTANTS?.YES &&
        dispatchGlobalpaymentsInitiatePaymentAction(props, checkoutDetails);
      // 3ds
      checkoutDetails?.globalPaymentCheck3DsVersion?.enrolled === GLOBAL_PAYMENTS_CONSTANTS?.ENROLLED &&
        initiateGlobalPayment3DsAuthentication(checkoutDetails, updateCheckoutDetails, props);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkoutDetails?.globalPaymentCheck3DsVersion?.serverTransactionId]);

  useEffect(() => {
    //  3ds frictionless
    (checkoutDetails?.globalPaymentAuthenticationData?.result === GLOBAL_PAYMENTS_CONSTANTS?.SUCCESS_AUTHENTICATED ||
      checkoutDetails?.globalPaymentAuthenticationData?.result === GLOBAL_PAYMENTS_CONSTANTS?.SUCCESS_ATTEMPT_MADE) &&
      dispatchGlobalpaymentsInitiatePaymentAction(props, checkoutDetails);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkoutDetails?.globalPaymentAuthenticationData?.result]);

  useEffect(() => {
    //  3ds challenge flow
    checkoutDetails?.globalPaymentAuthenticationData?.status === GLOBAL_PAYMENTS_CONSTANTS?.CHALLENGE_REQUIRED &&
      dispatchGlobalpaymentsInitiatePaymentAction(props, checkoutDetails);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkoutDetails?.globalPaymentAuthenticationData?.status]);

  useEffect(() => {
    (checkoutDetails?.globalPaymentAuthenticationData?.errors ||
      checkoutDetails?.globalPaymentCheck3DsVersion?.errors) &&
      redirectToPaymentFailurePage({ ...props });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkoutDetails?.globalPaymentAuthenticationData?.errors, checkoutDetails?.globalPaymentCheck3DsVersion?.errors]);

  return (
    checkoutDetails?.paymentCardDetails?.isFormValid && (
      <form id='global-payment-form' method='post' action='#'>
        <div id='credit-card'>
          <label for='card-number'>Card Number</label>
          <div id='card-number'></div>
          <label for='card-expiration'>Expiry Date</label>
          <div id='card-expiration'></div>
          <label for='card-cvv'>Security Code</label>
          <div id='card-cvv'></div>
          <label for='card-holder-name'>Cardholder Name</label>
          <div id='card-holder-name'></div>
        </div>
        <div id='submitGPFrom'></div>
      </form>
    )
  );
};

export default React.memo(GlobalPaymentCreditDebitCardHiddenForm);
